import React from 'react';

const withErrorBoundary = (Component) => {
  return class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasRenderError: false };
    }

    static getDerivedStateFromError() {
      return { hasRenderError: true };
    }

    render() {
      const { hasRenderError } = this.state;

      return <Component hasRenderError={hasRenderError} {...this.props} />;
    }
  };
};

export default withErrorBoundary;
